import { isLast } from "@punks/core"
import React from "react"
import CustomButton from "../../atoms/Button"
import ConditionalLink from "../../utilities/ConditionalLink"
import classes from "./Breadcrumb.module.css"

export interface BreadcrumbItem {
  name: string
  url?: string
}

interface Props {
  items: BreadcrumbItem[]
  itemMaxWidth?: string | number
}

const Breadcrumb = ({ items, itemMaxWidth }: Props) => {
  return (
    <div className="flex items-center max-w-full overflow-hidden">
      {items.map((item, index) => (
        <ConditionalLink
          className="flex items-center"
          link={item.url}
          key={index}
        >
          <CustomButton
            size="small"
            variant="text"
            invariantCase
            noMinWidth
            style={{ maxWidth: itemMaxWidth }}
            className={`${itemMaxWidth ? "truncate" : ""} ${
              classes.label ?? ""
            } ${isLast(index, items) ? classes.labelActive : ""}`}
          >
            {item.name}
          </CustomButton>
          {!isLast(index, items) && "/"}
        </ConditionalLink>
      ))}
    </div>
  )
}

export default Breadcrumb
